import { useEffect } from 'react';
import { message } from 'antd';
import { named } from '../inward/scanNames';
import { heldHandScans, onHeldHandScan } from './useHandScanner';

const KEY = 'held-hand-scan';

/** The line while a read waits for a screen that takes scans: it is kept, never "scan again" (that would count twice). */
export const heldScanText = (code: string) =>
  `Still loading. ${named(code)} is kept and used once this screen is ready.`;
/** The line once a kept read was used by no screen: nothing was done with it. */
export const droppedScanText = (code: string) =>
  `${named(code)} was not used. Nothing saved. Scan it again where it is needed.`;

/**
 * A hand-scanner read that came while no screen took scans (a page still loading, or a menu) is kept for the next one
 * (useHandScanner), and said: "Still loading. BO-B01 is kept…" until a screen takes it, or "… was not used. Nothing
 * saved." once none did (round 39, Kavya: a shelf read while Move Stock loaded vanished with no word).
 */
export const HeldScanNotice: React.FC = () => {
  useEffect(() => {
    const show = (code: string) =>
      message.info({ key: KEY, content: heldScanText(code), duration: 0 });
    const kept = heldHandScans();
    if (kept.length > 0) show(kept[kept.length - 1]);
    const off = onHeldHandScan(({ kind, code }) => {
      if (kind === 'held') show(code);
      else if (kind === 'used') {
        if (heldHandScans().length === 0) message.destroy(KEY);
      } else message.warning({ key: KEY, content: droppedScanText(code), duration: 6 });
    });
    return () => {
      off();
      message.destroy(KEY);
    };
  }, []);
  return null;
};
